// extracted by mini-css-extract-plugin
module.exports = {"fn-switch":"switch_fn-switch__37x_H","fn-switch-slider":"switch_fn-switch-slider__2ke7Q"};